import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Dispatch } from 'redux';
import { ApplicationState, SlidePanelContent, SlidePanelPosition, SlidePanelSide } from '../../store/';
import * as Actions from '../../store/actions';
import * as Selectors from '../../store/selectors';
import { Timeline, TimelineActions, TimelineProps } from './Timeline';

export const mapStateToProps: MapStateToProps<TimelineProps, any, ApplicationState> = (state, _) => {
  const { parentMediaId, startDate, endDate, viewModeType } = state.timeline;
  const { isLoading } = state.medias;
  return {
    isLoading,
    tree: Selectors.filterTreeSelector(state),
    medias: Selectors.mediasNormalizedSelector(state),
    parentMediaId,
    startDate,
    endDate,
    columns: Selectors.columnsSelector(state),
    itemsSource: Selectors.timelineDataSelector(state),
    viewModeType
  };
};

export const mapDispatchToProps: MapDispatchToProps<TimelineActions, any> = (dispatch: Dispatch, _) => ({
  getData: (parentMediaId: number) => dispatch<any>(Actions.MediaActions.fetchDataAsync(parentMediaId)),
  collapse: (treeId: string) => dispatch<any>(Actions.MediaActions.collapse(treeId)),
  expand: (treeId: string) => dispatch<any>(Actions.MediaActions.expand(treeId)),
  mediaSelected: (mediaId: number) => {
    dispatch(
      Actions.TimelineActions.setSlidePanelPositionAndContent(
        SlidePanelPosition.Docked,
        SlidePanelContent.MediaInfo,
        SlidePanelSide.Right
      )
    );
    dispatch(Actions.TimelineActions.setSelectedMediaId(mediaId));
  }
});
export const TimelineContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Timeline);



// WEBPACK FOOTER //
// ./src/components/timeline/TimelineContainer.ts